<template>
  <div
    :class="[
      'relative w-full h-full  rounded-md  border',
      `rarity-${equipment!.rarity}`,
    ]"
  >
    <img
      :src="equipment?.iconMedia?.url"
      class="w-full h-full object-contain p-1 img-render-nearest"
      crossorigin="anonymous"
    />

    <i
      v-if="showLock && equipment?.isLocked"
      class="iconify mingcute--lock-line absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 text-primary w-3"
    ></i>
  </div>
</template>

<script setup lang="ts">
import { MateEquipment } from "@/types/entity";

defineProps<{
  equipment?: MateEquipment;
  imageUrl?: string;
  rarity?: number | string;
  className?: string;
  showLock?: boolean;
}>();
</script>
